import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../../../core/services/api.config';
import {
  ClientLookupRequest,
  ClientLookupResponse,
  CreateClientRequest,
  CreateClientResponse,
  GetClientCasesResponse,
  GetClientDetailResponse,
  UpdateClientProfileRequest,
  UpdateClientProfileResponse,
  UpdateClientStatusRequest,
  UpdateClientStatusResponse,
} from '../models/client.models';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  searchInitialContact(
    payload: ClientLookupRequest,
  ): Observable<ClientLookupResponse> {
    return this.http.post<ClientLookupResponse>(
      `${this.apiBaseUrl}/clients/initial-contact/search`,
      payload,
      {
        withCredentials: true,
      },
    );
  }

  createClient(payload: CreateClientRequest): Observable<CreateClientResponse> {
    return this.http.post<CreateClientResponse>(
      `${this.apiBaseUrl}/clients`,
      payload,
      {
        withCredentials: true,
      },
    );
  }

  getClientDetail(clientId: number): Observable<GetClientDetailResponse> {
    return this.http.get<GetClientDetailResponse>(`${this.apiBaseUrl}/clients/${clientId}`, {
        withCredentials: true,
      });
  }

  getClientCases(
    clientId: number,
    status: 'open' | 'closed',
  ): Observable<GetClientCasesResponse> {
    return this.http.get<GetClientCasesResponse>(`${this.apiBaseUrl}/clients/${clientId}/cases`, {
      params: { status },
      withCredentials: true,
    });
  }

  updateClientProfile(
    clientId: number,
    payload: UpdateClientProfileRequest,
  ): Observable<UpdateClientProfileResponse> {
    return this.http.patch<UpdateClientProfileResponse>(
      `${this.apiBaseUrl}/clients/${clientId}/profile`,
      payload,
      {
        withCredentials: true,
      },
    );
  }

  updateClientStatus(
    clientId: number,
    payload: UpdateClientStatusRequest,
  ): Observable<UpdateClientStatusResponse> {
    return this.http.patch<UpdateClientStatusResponse>(
      `${this.apiBaseUrl}/clients/${clientId}/status`,
      payload,
      {
        withCredentials: true,
      },
    );
  }
}